export interface ArticleMeta {
  slug: string;
  date: string;
  image: string;
}

export const articleMeta: ArticleMeta[] = [
  {
    slug: "allchinabuy-spreadsheet",
    date: "2026-08-24",
    image:
      "https://readdy.ai/api/search-image?query=A%20clean%20minimal%20desk%20scene%20with%20a%20laptop%20showing%20an%20organized%20spreadsheet%20with%20rows%20and%20columns%2C%20a%20small%20notebook%20and%20a%20tiny%20potted%20plant%2C%20soft%20natural%20daylight%2C%20pastel%20mint%20green%20and%20warm%20cream%20tones%2C%20calm%20airy%20editorial%20photography%2C%20no%20text%2C%20no%20watermark&width=800&height=600&seq=article-spreadsheet&orientation=landscape",
  },
  {
    slug: "allchinabuy-finds",
    date: "2026-08-20",
    image:
      "https://readdy.ai/api/search-image?query=A%20neatly%20arranged%20flat%20lay%20of%20assorted%20streetwear%20items%20including%20sneakers%2C%20a%20cap%2C%20sunglasses%20and%20a%20small%20bag%20on%20a%20warm%20sand%20beige%20surface%2C%20soft%20natural%20light%2C%20clean%20editorial%20product%20photography%2C%20no%20text%2C%20no%20watermark%2C%20fresh%20and%20inviting&width=800&height=600&seq=article-finds&orientation=landscape",
  },
  {
    slug: "allchinabuy-review",
    date: "2026-08-18",
    image:
      "https://readdy.ai/api/search-image?query=A%20top-down%20view%20of%20a%20smartphone%20and%20a%20notebook%20on%20a%20light%20desk%20showing%20a%20product%20review%20concept%20with%20five%20star%20rating%20icons%20made%20of%20small%20yellow%20paper%20stars%2C%20soft%20daylight%2C%20minimal%20editorial%20photography%2C%20no%20text%2C%20no%20watermark%2C%20clean%20and%20warm&width=800&height=600&seq=article-review&orientation=landscape",
  },
  {
    slug: "allchinabuy-shipping-cost",
    date: "2026-08-16",
    image:
      "https://readdy.ai/api/search-image?query=A%20stack%20of%20neatly%20sealed%20cardboard%20shipping%20boxes%20with%20a%20soft%20measuring%20tape%20and%20a%20small%20parcel%20scale%20on%20a%20light%20wood%20table%2C%20warm%20natural%20light%2C%20clean%20minimal%20logistics%20product%20photography%2C%20no%20text%2C%20no%20watermark%2C%20calm%20and%20organized&width=800&height=600&seq=article-shipping&orientation=landscape",
  },
  {
    slug: "allchinabuy-coupon",
    date: "2026-08-14",
    image:
      "https://readdy.ai/api/search-image?query=A%20pair%20of%20scissors%20next%20to%20a%20folded%20discount%20voucher%20and%20a%20small%20stack%20of%20coins%20on%20a%20soft%20mint%20green%20surface%2C%20bright%20airy%20daylight%2C%20minimal%20clean%20savings%20concept%20photography%2C%20no%20text%2C%20no%20watermark%2C%20fresh%20and%20tidy&width=800&height=600&seq=article-coupon&orientation=landscape",
  },
  {
    slug: "allchinabuy-warehouse",
    date: "2026-08-12",
    image:
      "https://readdy.ai/api/search-image?query=A%20bright%20clean%20warehouse%20interior%20with%20neatly%20organized%20shelves%20of%20small%20boxes%20and%20a%20worker%20scanning%20a%20parcel%20in%20the%20background%2C%20soft%20daylight%20through%20high%20windows%2C%20minimal%20clean%20logistics%20photography%2C%20no%20text%2C%20no%20watermark%2C%20calm%20and%20orderly&width=800&height=600&seq=article-warehouse&orientation=landscape",
  },
  {
    slug: "allchinabuy-legit",
    date: "2026-08-10",
    image:
      "https://readdy.ai/api/search-image?query=A%20clean%20desk%20with%20a%20magnifying%20glass%20resting%20on%20a%20document%20and%20a%20green%20checkmark%20drawn%20on%20a%20sticky%20note%2C%20soft%20natural%20light%2C%20minimal%20trust%20and%20verification%20concept%20photography%2C%20no%20text%2C%20no%20watermark%2C%20calm%20and%20reassuring&width=800&height=600&seq=article-legit&orientation=landscape",
  },
  {
    slug: "allchinabuy-qc",
    date: "2026-08-08",
    image:
      "https://readdy.ai/api/search-image?query=A%20close-up%20of%20a%20person%20inspecting%20a%20small%20clothing%20item%20with%20a%20magnifying%20glass%20under%20bright%20clean%20light%20on%20a%20white%20work%20surface%2C%20minimal%20quality%20control%20concept%20photography%2C%20no%20text%2C%20no%20watermark%2C%20precise%20and%20clean&width=800&height=600&seq=article-qc&orientation=landscape",
  },
  {
    slug: "allchinabuy-buying-guide",
    date: "2026-08-06",
    image:
      "https://readdy.ai/api/search-image?query=A%20tidy%20shopping%20scene%20with%20a%20laptop%2C%20a%20small%20cart%20icon%20and%20neatly%20folded%20clothes%20on%20a%20light%20desk%2C%20warm%20natural%20light%2C%20minimal%20beginner%20buying%20guide%20concept%20photography%2C%20no%20text%2C%20no%20watermark%2C%20fresh%20and%20welcoming&width=800&height=600&seq=article-buying&orientation=landscape",
  },
  {
    slug: "allchinabuy-safe",
    date: "2026-08-04",
    image:
      "https://readdy.ai/api/search-image?query=A%20minimalist%20padlock%20icon%20shape%20made%20of%20soft%20light%20materials%20resting%20on%20a%20clean%20cream%20desk%20with%20soft%20daylight%2C%20calm%20safety%20and%20security%20concept%20photography%2C%20no%20text%2C%20no%20watermark%2C%20gentle%20and%20reassuring&width=800&height=600&seq=article-safe&orientation=landscape",
  },
];